var map = {
	"./eight.png": 2660,
	"./five.png": 5400,
	"./four.png": 6741,
	"./fourteen.png": 1989,
	"./nine.png": 5727,
	"./one.png": 6510,
	"./seven.png": 6990,
	"./ten.png": 2676,
	"./thirteen.png": 3651,
	"./twelve.png": 6337,
	"./two.png": 2561
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8631;